// extracted by mini-css-extract-plugin
export default {"mobile":"iFiqaE","root":"EdMH8t","onImage":"kFjtai"};